import { memo } from "react";
import { useSelector } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { ThemedPowerOff } from "assets/CXFIcons/Triggers";

const ButtonSwitchState = ({ title, toggleNodeState, allowEditWorkflow }) => {
  const { currentSavedFlow } = useSelector((state) => state.designer.flows);
  const isActiveFlow = currentSavedFlow?.shared_status === "active";

  return (
    <Tooltip title={title} placement="top">
      <IconButton
        aria-label="disable"
        size="small"
        style={{ width: "100%", height: "100%" }}
        onClick={toggleNodeState}
        disabled={isActiveFlow || !allowEditWorkflow}
      >
        <ThemedPowerOff width="19px" height="19px" color="currentColor" />
      </IconButton>
    </Tooltip>
  );
};

export default memo(ButtonSwitchState);
